var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "confirm-line-haul-connection"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('br'), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "card-body1",
    staticStyle: {
      "margin-top": "-18px"
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.showdetails()
      }
    }
  }, [_c('legend', [_vm._v("Forward Sticker Print")]), _vm._v(" "), _c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Scan Shipping Id")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-barcode'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.barcode),
      expression: "barcode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    ref: "barcode",
    class: {
      'form-control': true, 'error': _vm.errors.has('barcode')
    },
    attrs: {
      "name": "barcode",
      "disabled": _vm.isDisabled
    },
    domProps: {
      "value": (_vm.barcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.barcode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('barcode')),
      expression: "errors.has('barcode')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(" Shipping Id field is required.")])], 1), _vm._v(" "), (_vm.showIconInput) ? _c('b-form-fieldset', [_c('b-input-group', _vm._b({}, 'b-input-group', _vm.colorCodeClassIcon(_vm.colorCode, _vm.colorIcon), false), [_vm._v(_vm._s(_vm.shippingIdForColor))])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit",
      "disabled": _vm.isDisabled
    }
  }, [_c('span', {
    staticClass: "fa fa-print"
  }), _vm._v(" Print")]), _vm._v("  \n                  "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset",
      "disabled": _vm.isDisabled
    },
    on: {
      "click": function($event) {
        return _vm.resetData()
      }
    }
  }, [_c('span'), _vm._v("Reset")]), _vm._v("  \n                  ")])], 1)], 1)])], 1)], 1)]), _vm._v(" "), (_vm.showTable) ? _c('div', {
    staticClass: "card-body1"
  }, [_c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Shipment ID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Shipment Type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Customer Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Customer Address")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("RTO Hub Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("RTO Address")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Destination Hub")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Delivery Pincode")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Last Modified Date")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.shipmentData.ShippingID))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.shipmentData.Bussiessflow))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.shipmentData.CustomerName))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.shipmentData.CustomerAddress))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.shipmentData.destiRtoHubName))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.shipmentData.RTOAddress))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.shipmentData.destinationhubname) + " (" + _vm._s(_vm.shipmentData.FinalDestinationID) + ")")]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.shipmentData.CustomerPinCode))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.shipmentData.LastModifedDate)))])])])])])])])], 1) : _vm._e()])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b18e1c6c","hasScoped":true}!./src/views/components/PrintForwardSticker/PrintForwardSticker.html
// module id = 1971
// module chunks = 2